module.exports = __webpack_public_path__ + "static/retail_final-647e95db3a04f167cff4a094ea0c32f1.png";